import { useRouter } from 'expo-router';
import { StatusBar } from 'expo-status-bar';
import { StyleSheet } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import { onboardingColors } from '@/components/atoms/onboarding/tokens';
import { OnboardingFlow } from '@/components/organisms/onboarding/OnboardingFlow';
import { OnboardingStep, type OnboardingStepValue } from '@/stores/createOnboardingStore';
import { useOnboardingStore } from '@/stores/useOnboardingStore';
import { useAppTheme } from '@/theme';

export const Onboarding = () => {
  const router = useRouter();
  const { colors } = useAppTheme();
  const currentStep = useOnboardingStore((state) => state.currentStep);
  const completeOnboarding = useOnboardingStore((state) => state.completeOnboarding);
  const goToStep = useOnboardingStore((state) => state.goToStep);
  const skipOnboarding = useOnboardingStore((state) => state.skipOnboarding);
  const startOnboarding = useOnboardingStore((state) => state.startOnboarding);
  const userId = useOnboardingStore((state) => state.userId);

  const handleStepChange = (step: OnboardingStepValue) => {
    if (currentStep === OnboardingStep.welcome) {
      startOnboarding();
    }

    goToStep(step);
  };

  const handleSkip = () => {
    if (userId) {
      void skipOnboarding(userId, currentStep);
    }

    router.replace('/meetings');
  };

  const handleDone = () => {
    if (userId) {
      void completeOnboarding(userId);
    }

    router.replace('/meetings');
  };

  const isTutorial = currentStep !== OnboardingStep.welcome;
  const statusBarBackground = isTutorial
    ? onboardingColors.illustrationBackground
    : colors.background;

  return (
    <SafeAreaView style={[styles.container, { backgroundColor: statusBarBackground }]}>
      <StatusBar />
      <OnboardingFlow
        currentStep={currentStep}
        onDone={handleDone}
        onSkip={handleSkip}
        onStepChange={handleStepChange}
      />
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});
